export const getAuthToken = () => localStorage.getItem("auth-token");
export const setAuthToken = token => localStorage.setItem("auth-token", token);
export const clearAuthToken = () => {
  localStorage.removeItem("auth-token")
}